<div class="hero"></div>
<div class="container">
  <form [formGroup]="frmSearch" (ngSubmit)="submitSearch()">
    <div class="search grid">
      <div class="banner">
        <h1>Gruppi in partenza</h1>
        <span>Scopri tutti i nostri gruppi in partenza e prenota il tuo
          viaggio</span>
      </div>

      <div class="col-12 md:col">
        <div class="search-input">
          <p-autoComplete [forceSelection]="true" formControlName="destinations" placeholder="Destinazione"
            [suggestions]="suggestedCountries" (completeMethod)="filterCountries($event)" field="name" dataKey="ISO"
            class="frm mt-1" [emptyMessage]="'Nessun risultato trovato'" [showClear]="true">
          </p-autoComplete>
        </div>
      </div>
      <div class="col-12 md:col">
        <div class="search-input">
          <p-multiSelect styleClass="w-full" [options]="types" [filter]="false" [showHeader]="false" optionLabel="name"
            optionValue="id" [showClear]="true" formControlName="categories" placeholder="Categorie"
            emptyMessage="Nessun risultato trovato.">
            <ng-template let-t pTemplate="type">
              <div class="flex align-items-center gap-2">
                <img [src]="t.id | travelType" />
                <span>{{ t.name }}</span>
              </div>
            </ng-template>
          </p-multiSelect>
        </div>
      </div>
      <div class="col-12 md:col">
        <p-autoComplete formControlName="leader" styleClass="w-full" [suggestions]="suggestedLeaders"
          (completeMethod)="filterLeaders($event)" placeholder="Organizzatore" dataKey="id" [forceSelection]="true"
          emptyMessage="Nessun risultato" emptyFilterMessage="Nessun risultato trovato"
          [optionLabel]="getLeadersNameToDisplay" [showClear]="true">
          <ng-template let-leader pTemplate="item">
            <div class="flex align-items-center gap-2">
              <p-avatar [image]="leader.profile_picture | imagePipe: 'user' : 'sm'" shape="circle"></p-avatar>
              <div>{{ leader.name }} {{ leader.last_name }}</div>
            </div>
          </ng-template>
        </p-autoComplete>
      </div>

      <div class="col-12 md:col">
        <div class="flex align-items-center justify-content-center gap-3 mt-3">
          <p-inputSwitch formControlName="flight" inputId="flight" />
          <label for="flight" class="text-sm mb-1">Voli inclusi</label>
        </div>
      </div>
      <div class="col-12 md:col">
        <p-button styleClass="w-full slide" label="Cerca" size="small" type="submit"></p-button>
      </div>
      <button pButton type="button" (click)="resetFilters()" class="p-button-rounded p-button-text"
        icon="pi pi-filter-slash" pTooltip="Reset filtri"></button>
    </div>
  </form>

  @if (loading) {
  <div class="backdrop-mini-loader">
    <i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
  </div>
  } @else {
  <div class="mt-6 mb-10">
    <div class="grid">
      @for (t of travels; track $index) {
      <div class="col-12 md:col-6 lg:col-4 xl:col-3">
        <div class="card-blur-container">
          <app-travel-card-minimal [travel]="t"></app-travel-card-minimal>

          @if (
          !t.funding && t.visibility.id === 2
          ) {
          <div class="blur-overlay"></div>
          <div class="private-badge">Viaggio privato</div>
          }
        </div>
      </div>
      <!-- @if (auth.isLogged() && auth.getUserId() === user!.id) {
            <div class="col-12 md:col-6 lg:col-4 xl:col-3">
              <app-travel-card-minimal [travel]="t"></app-travel-card-minimal>
            </div>
          } @else {
            <div class="col-12 md:col-6 lg:col-4 xl:col-3">
              <div class="card-blur-container">
                <app-travel-card-minimal [travel]="t"></app-travel-card-minimal>
                @if (t.funding) {
                  <div class="blur-overlay"></div>
                  <div class="private-badge">Viaggio privato</div>
                }
              </div>
            </div>
          } -->
      }
    </div>

    @if (totalRecords === 0) {
    <div class="flex align-items-center justify-content-center mt-7 mb-6">
      <div class="empty-set px-0">
        <img src="/assets/media/illustrations/map.png" height="200" />
        <h5>Nessun risultato</h5>
      </div>
    </div>
    }
    @if (totalRecords > travels.length) {
    <div class="flex align-items-center justify-content-center mt-7">
      @if (loadingMore) {
      <i class="pi pi-spin pi-spinner" style="font-size: 1.5rem"></i>
      } @else {
      <p-button label="Mostra altro" styleClass="slide px-6" size="small" (click)="showMore()"></p-button>
      }
    </div>
    }
  </div>
  }
</div>

<app-request></app-request>